import type { IPlayer } from "../../types/types";
import { PlayerCard } from "./players/PlayerCard";

export { isPrimaryPlayer, sortPlayersByPosition, teamDescription } from "./constants";

const rosterGridClassName =
  "grid w-full grid-cols-5 items-stretch gap-4 max-[1100px]:grid-cols-3 max-[720px]:grid-cols-2 max-[720px]:gap-3 max-[420px]:grid-cols-1";

export const TeamRosterSection = ({
  title,
  players,
  isSubstitutes = false,
}: {
  title: string;
  players: IPlayer[];
  isSubstitutes?: boolean;
}) => {
  if (!players.length) {
    return null;
  }

  return (
    <section
      className={`w-full text-left ${isSubstitutes ? "border-t border-white/8 pt-[1.35rem]" : ""}`}
    >
      <h3 className={`fh-title-eyebrow mb-[0.9rem] ${isSubstitutes ? "text-white/72" : ""}`}>
        {title}
      </h3>
      <div className={rosterGridClassName}>
        {players.map((player) => (
          <PlayerCard key={player.id} player={player} linkToProfile />
        ))}
      </div>
    </section>
  );
};
